import React, { Component } from 'react';
import ErrorList from '../../components/ErrorList';
import { bindActionCreators } from 'redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import AuthService from '../../services/api/auth';
import { setSubscriptionsPlans, setCurrency } from '../../redux/subscriptions/actions';
import { plansSelector, currencySelector } from '../../redux/subscriptions/selector';
import { languageSelector } from '../../redux/application/selector';

import Iframe from 'react-iframe';
import Modal from 'react-modal';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

const PlanDetail = (plan, selectedPlan, onChange, currency, toggleModal, language) => {
    const isSelected = () => selectedPlan === plan.id;
    let planClasses = 'plan p-3 mb-3 rounded shadow-sm';
    planClasses = isSelected() ? `${planClasses} border-primary` : planClasses;
    const isFreePlan = () => plan.id === 'FREE_PLAN';
    const description =
        plan.id === 'FREE_PLAN' ? window.VULOG_CONFIG.FREE_PLAN_DESCRIPTION : window.VULOG_CONFIG.PLAN_DESCRIPTION;
    const freePlanName = window.VULOG_CONFIG.FREE_PLAN_NAME || 'Backup Plan';
    const planName = isFreePlan() ? freePlanName : plan.name;
    const period = isFreePlan() ? 'MONTH' : plan.period;
    const format = language.replace('_', '-') || 'en-GB';

    const handlePrice = price => {
        let formatter = new Intl.NumberFormat(format, {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        return `${formatter.format(price)} `;
    };

    return (
        <div key={plan.id} className={planClasses}>
            <div className="form-check px-4">
                <input
                    className="form-check-input plan__input"
                    type="radio"
                    name="plan"
                    id={plan.id}
                    value={plan.id}
                    checked={isSelected()}
                    aria-label={plan.name}
                    onChange={e => onChange(e)}
                />
                <label className="form-check-label plan__label text-center" htmlFor={plan.id}>
                    <h4 className="mb-0">{planName}</h4>
                    <div className="plan__price text-primary mb-2">
                        <h3 className="text-primary mb-0">
                            {/* need product data */}
                            {handlePrice(plan.price)}/{translate(period)}
                        </h3>
                    </div>
                    <div className="plan__detail">
                        <div>{description}</div>
                        <button className="btn btn-primary btn-block mt-3" onClick={() => toggleModal(true)}>
                            {translate('Check Pricing')}
                        </button>
                    </div>
                </label>
            </div>
        </div>
    );
};

const PricingModal = ({ isModalOpen, toggleModal }) => {
    const url = window.VULOG_CONFIG.PLAN_PRICING_URL;
    return (
        <Modal
            isOpen={isModalOpen}
            portalClassName="e-modal"
            overlayClassName="e-modal__overlay"
            className="e-modal__content e-modal__content-top"
            bodyOpenClassName="e-modal--is-open"
            htmlOpenClassName="prevent-scroll"
            shouldFocusAfterRender={false}
            ariaHideApp={false}
        >
            <Iframe url={url} display="initial" position="relative" className="iframe" frameBorder={0} />
            <div className={'e-modal__button-container'}>
                <button
                    onClick={() => toggleModal(false)}
                    type="button"
                    className="e-modal__button-close btn btn-primary btn-block"
                    aria-label="Close"
                >
                    {translate('Close')}
                </button>
            </div>
        </Modal>
    );
};

class SubscriptionsScreen extends Component {
    state = {
        selectedPlan: 'FREE_PLAN',
        isModalOpen: false,
        isSaveBtnDisabled: false,
    };

    componentDidMount() {
        AuthService.getSubscriptions().then(data => {
            const { onSetSubscriptionsPlans } = this.props;
            onSetSubscriptionsPlans(data);
        });
        AuthService.getCurrency().then(data => {
            const { onSetCurrency } = this.props;
            onSetCurrency(data);
        });
    }

    save() {
        const { selectedPlan } = this.state;
        this.setState({ isSaveBtnDisabled: true });
        AuthService.createSubscription(selectedPlan)
            .then(response => {
                if (response.next === null) {
                    this.props.history.push('/register/status');
                } else {
                    this.props.history.push(response.next);
                }
            })
            .catch(error => {
                console.log('Error while trying to select a plan', error);
                this.setState({ isSaveBtnDisabled: false });
            });
    }

    onChange = e => {
        this.setState({ selectedPlan: e.target.value });
    };

    toggleModal = value => {
        this.setState({ isModalOpen: value });
    };

    render() {
        const { allPlans, currency, language } = this.props;
        const { selectedPlan, isModalOpen, isSaveBtnDisabled } = this.state;
        return (
            <div className="container-fluid wrapper services">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{translate('MOBILTY_PLANS')}</h3>
                </div>
                <div className="flex-grow-1">
                    {window.VULOG_CONFIG && window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                        <ErrorList errors={this.state.errors} />
                    )}

                    {allPlans &&
                        allPlans.length >= 1 &&
                        currency &&
                        currency !== '' &&
                        allPlans
                            .sort((a, b) => a.price - b.price)
                            .map(plan =>
                                PlanDetail(plan, selectedPlan, this.onChange, currency, this.toggleModal, language)
                            )}
                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}
                </div>
                <div className="d-flex flex-row mt-auto mb-1-5rem">
                    <button
                        className="btn btn-primary btn-block"
                        onClick={() => this.save()}
                        disabled={isSaveBtnDisabled}
                    >
                        {translate('Next')}
                        <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                    </button>
                </div>
                <PricingModal isModalOpen={isModalOpen} toggleModal={this.toggleModal} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    position: state.register.position,
    allPlans: plansSelector(state),
    currency: currencySelector(state),
    language: languageSelector(state),
});
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

const mapDispatchToProps = dispatch => ({
    onRegisterActions: bindActionCreators(registerActions, dispatch),
    onSetSubscriptionsPlans: bindActionCreators(setSubscriptionsPlans, dispatch),
    onSetCurrency: bindActionCreators(setCurrency, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SubscriptionsScreen));
